import { render } from "./PageSwitcher.vue?vue&type=template&id=2c37988c&scoped=true"
import script from "./PageSwitcher.vue?vue&type=script&lang=js"
export * from "./PageSwitcher.vue?vue&type=script&lang=js"

import "./PageSwitcher.vue?vue&type=style&index=0&id=2c37988c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c37988c"]])

export default __exports__